// @flow
export type IncrementAction = {type: "INCREMENT_BUNDLE", id: number};
export type DecrementAction = {type: "DECREMENT_BUNDLE", id: number};
export type SetAction = {type: "SET_BUNDLE", id: number, value: number};
export type SetBundleProductConfigAction = {type: "SET_BUNDLE_PRODUCT_CONFIG", id: number, configuration: object};
export type SetBundlesQuantitiesAction = {type: "SET_NEW_BUNDLE_QUANTITIES", quantities: Object};

export type FetchAction = {type: "FETCH_EVENT", data: Object};

export type Action = IncrementAction | DecrementAction | SetAction | FetchAction | SetBundleProductConfigAction | SetBundlesQuantitiesAction;

type State = { +bundleQuantityArrays: Object, +bundleQuantities: Object, +selectedConfigurations: Object, +availableQuantities: Object, +initialQuantities: Object };

let initialState = { bundleQuantityArrays: {}, bundleQuantities: {}, selectedConfigurations: {}, availableQuantities: {}, initialQuantities: {} };

/** Reducer for bundle picker actions */
export function bundlePicker(state: State = initialState, action:Action): State {
    if(action.type === "INCREMENT_BUNDLE") {
        let newState = {...state};
        newState.bundleQuantities = {...newState.bundleQuantities};

        if(!newState.bundleQuantities[action.id]) {
            newState.bundleQuantities[action.id] = newState.bundleQuantityArrays[action.id][0];
        } else {
            let newIndex = newState.bundleQuantityArrays[action.id].indexOf(newState.bundleQuantities[action.id]) + 1;
            newState.bundleQuantities[action.id] = newIndex >= newState.bundleQuantityArrays[action.id].length ? newState.bundleQuantities[action.id] : newState.bundleQuantityArrays[action.id][newIndex];
        }

        return newState;
    } else if(action.type === "DECREMENT_BUNDLE") {
        let id = action.id;
        let newState = {...state};
        newState.bundleQuantities = {...newState.bundleQuantities};

        let newIndex = newState.bundleQuantityArrays[id].indexOf(newState.bundleQuantities[id]) - 1;

        if(newIndex < 0) {
            delete newState.bundleQuantities[id];
            if (newState.selectedConfigurations[id]) {
                delete newState.selectedConfigurations[id];
            }
        } else {
            newState.bundleQuantities[id] = newState.bundleQuantityArrays[id][newIndex];
            if (newState.selectedConfigurations[id]) {
                Object.keys(newState.selectedConfigurations[id]).map((key, i) => {
                    if (Object.keys(newState.selectedConfigurations[id][key]).length > 0) {
                        delete newState.selectedConfigurations[id][key][Object.keys(newState.selectedConfigurations[id][key]).length - 1];
                    } else {
                        delete newState.selectedConfigurations[id][key];
                    }
                })
            }
        }

        return newState;
    }  else if(action.type === "SET_BUNDLE") {
        let newState = {...state};

        newState.bundleQuantities = {...newState.bundleQuantities};
        let newIndex = newState.bundleQuantityArrays[action.id].indexOf(action.value);
        newState.bundleQuantities[action.id] = newState.bundleQuantityArrays[action.id][newIndex];

        return newState;
    }  else if(action.type === "SET_BUNDLES") {
        let newState = {...state};

        newState.bundleQuantities = {...newState.bundleQuantities};
        newState.initialQuantities = {...newState.initialQuantities};

        for(let i = 0; i < action.data.length; i++) {
            newState.bundleQuantityArrays[action.data[i].id] = buildBundleQuantityArray(action.data[i]);
            newState.initialQuantities[action.data[i].id] = buildBundleQuantityArray(action.data[i]);
        }

        return newState;
    }   else if(action.type === "SET_BUNDLE_PRODUCT_CONFIG") {
        let bundleId = action.configuration["bundleId"];
        let configId = action.configuration["configurationId"];
        let productId = action.configuration["productId"];
        let index = action.configuration["index"];

        let newState = {...state};
        newState.selectedConfigurations = {...newState.selectedConfigurations};
        newState.selectedConfigurations[bundleId] = {...newState.selectedConfigurations[bundleId]};
        newState.selectedConfigurations[bundleId][productId] = {...newState.selectedConfigurations[bundleId][productId]};
        newState.selectedConfigurations[bundleId][productId][index] = {};
        if (configId !== "") {
            if (newState.selectedConfigurations[bundleId][productId][index][configId] === undefined) {
                newState.selectedConfigurations[bundleId][productId][index][configId] = 1;
            } else {
                newState.selectedConfigurations[bundleId][productId][index][configId] += 1;
            }
        } else {
            if (newState.selectedConfigurations[bundleId][productId][index]) {
                delete newState.selectedConfigurations[bundleId][productId][index];
            }
        }

        return newState;
    }  else if(action.type === "SET_BUNDLE_SALES") {
        let newState = {...state};
        newState.bundleQuantities = {};
        newState.selectedConfigurations = {};
        return newState;
    }  else if(action.type === "SET_NEW_BUNDLE_QUANTITIES") {
        let newState = {...state};
        newState.availableQuantities = action.quantities;

        return newState;
    } else if(action.type === "FETCH_EVENT" || action.type === "REFRESH_EVENT") {
        let newState = {...state};

        for (const eventId in action.data.attributes.events) {
            let eventBundles = action.data.attributes.events[eventId].bundles;
            for(let i = 0; i < eventBundles.length; i++) {
                newState.bundleQuantityArrays[eventBundles[i].id] = buildBundleQuantityArray(eventBundles[i]);
                newState.initialQuantities[eventBundles[i].id] = buildBundleQuantityArray(eventBundles[i]);
            }
        }

        return newState;
    }  else if(action.type === "RESERVATION_CLEARED" || action.type === "CLEAR_SELECTED_BUNDLES") {
        if(!action.reset && action.type !== "CLEAR_SELECTED_BUNDLES") {
            return state;
        }

        let newState = {...state};
        newState.bundleQuantities = {};
        newState.selectedConfigurations = {};
        newState.availableQuantities = {};
        return newState;
    } else {
        return state;
    }
}

export function buildBundleQuantityArray(bundle) {
    let min = (bundle.min_purchase_limit === 0 || bundle.min_purchase_limit === null) ? 1 : bundle.min_purchase_limit;
    let max = bundle.max_purchase_limit;
    let increment_by = bundle.increment_by;
    let quantities = [];
    for(var i = parseInt(min); i <= parseInt(max); i += increment_by) {
        quantities.push(i);
    }

    return quantities;
}
